<h3 class="font-bold">{{ 'flu.pharmacy-association.title' | cxTranslate }}</h3>
<div class="d-flex gap-1 align-items-center" [formGroup]="form">
  <label class="c-text-input m-0 w-100">
    <input
      type="text"
      class="form-control"
      formControlName="pharmacyAssociation"
      name="pharmacyAssociation"
      (input)="clearStatus()"
      [placeholder]="'flu.pharmacy-association.placeholder' | cxTranslate" />
  </label>

  <button
    type="button"
    class="c-button c-button--primary"
    (click)="onSubmit()"
    *ngIf="!form.disabled">
    {{ 'common.apply' | cxTranslate }}
  </button>
</div>
<span class="c-text color-error" *ngIf="submitResult()?.success === false">
  {{ 'flu.pharmacy-association.invalidCode' | cxTranslate }}
</span>
<span class="c-text" *ngIf="submitResult()?.success === true">
  {{ 'flu.pharmacy-association.codeApplied' | cxTranslate }}
</span>
